/**
 * Appointment type constants — single source of truth for the frontend.
 * When adding a new type: add it to APPOINTMENT_TYPES, APPOINTMENT_TYPE_LABELS,
 * and APPOINTMENT_TYPE_BADGES. Also update backend/app/constants.py and the
 * Alembic migration + SQL schema CHECK constraint.
 */

export type AppointmentType = 'billable' | 'pro_bono' | 'barter' | 'complimentary';

export const DEFAULT_APPOINTMENT_TYPE: AppointmentType = 'billable';

/** Ordered list used to populate dropdowns and button groups. */
export const APPOINTMENT_TYPES: AppointmentType[] = [
  'billable',
  'pro_bono',
  'barter',
  'complimentary',
];

export const APPOINTMENT_TYPE_LABELS: Record<AppointmentType, string> = {
  billable:      'Billable',
  pro_bono:      'Pro Bono',
  barter:        'Barter',
  complimentary: 'Complimentary',
};

/** Badge style used in session lists and summary panels. null = no badge (default). */
export const APPOINTMENT_TYPE_BADGES: Record<AppointmentType, { label: string; className: string } | null> = {
  billable:      null,
  pro_bono:      { label: 'Pro Bono',      className: 'bg-blue-100 text-blue-800' },
  barter:        { label: 'Barter',        className: 'bg-amber-100 text-amber-800' },
  complimentary: { label: 'Complimentary', className: 'bg-green-100 text-green-800' },
};

/** Dark-theme badge style used in coaching log / calendar views. */
export const APPOINTMENT_TYPE_DARK_BADGES: Record<AppointmentType, { label: string; cls: string }> = {
  billable:      { label: 'Billable',      cls: 'bg-blue-900/40 text-blue-400 border-blue-800' },
  pro_bono:      { label: 'Pro Bono',      cls: 'bg-purple-900/40 text-purple-400 border-purple-800' },
  barter:        { label: 'Barter',        cls: 'bg-amber-900/40 text-amber-400 border-amber-800' },
  complimentary: { label: 'Complimentary', cls: 'bg-green-900/40 text-green-400 border-green-800' },
};

export function getAppointmentTypeLabel(type: string): string {
  return APPOINTMENT_TYPE_LABELS[type as AppointmentType] ?? type;
}
